import { useTranslation } from 'react-i18next';

import { ActionIcon, Box, Group, Table, Text, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { CartProduct } from '@interfaces/cart.interface';
import { useUpdateCartMutation } from '@api/cart.api';

interface CartProductsTableProps {
  products: CartProduct[];
}

export default function CartProductsTable({
  products,
}: CartProductsTableProps) {
  const { t } = useTranslation();

  const [updateCart, { isLoading: isLoadingUpdateCart }] =
    useUpdateCartMutation();

  const handleRemoveProduct = async (productId: string) => {
    await updateCart({
      products: products.filter((p) => p.productId !== productId),
    });
  };

  return (
    <Table>
      <Table.Thead>
        <Table.Tr bg="#dee0e2" c="#000">
          <Table.Th py="md">{t('table.code')}</Table.Th>
          <Table.Th py="md">{t('table.name')}</Table.Th>
          <Table.Th py="md">{t('table.quantity')}</Table.Th>
          <Table.Th py="md">
            {t('table.unitPrice')}
            <Box display="inline" visibleFrom="md">
              {' '}
              ({t('table.vatExcluded')})
            </Box>
          </Table.Th>
          <Table.Th py="md" ta="right">
            {t('table.actions')}
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody fw={600}>
        {products.map((product) => (
          <Table.Tr key={product.productId}>
            <Table.Td>{product.productId}</Table.Td>
            <Table.Td>{product.productName}</Table.Td>
            <Table.Td>{product.quantity}</Table.Td>
            <Table.Td>
              € {product.unitPrice.toFixed(2)}
              <Text size="sm" c="dimmed" hiddenFrom="md">
                {t('table.vatIncluded')}
              </Text>
            </Table.Td>
            <Table.Td>
              <Group gap="xs" wrap="nowrap" justify="flex-end">
                <Tooltip label={t('cart.removeProduct')}>
                  <ActionIcon
                    variant="subtle"
                    color="grey"
                    disabled={isLoadingUpdateCart}
                    onClick={() => handleRemoveProduct(product.productId)}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Tooltip>
              </Group>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
